import { c as n, j as r } from "./createRuntimeFn-62c9670f.esm-CXdMsbWY.js";
import { $ as m } from "./import-_PjWeMm4.js";
/* empty css                              */
import { B as o } from "./Typography-2ZjCxfuP.js";
import { vars as t } from "./theme.js";
var d = "_1g2c7v70", v = n({ defaultClassName: "_1g2c7v71", variantClassNames: { checked: { true: "_1g2c7v72" }, disabled: { true: "_1g2c7v73" }, error: { true: "_1g2c7v74" } }, defaultVariants: {}, compoundVariants: [[{ checked: !0, error: !0 }, "_1g2c7v75"]] }), g = "_1g2c7v76";
const j = ({
  checked: e,
  children: c,
  disabled: s,
  error: a,
  message: i,
  ...l
}) => /* @__PURE__ */ r.jsxs(
  m,
  {
    ...l,
    isDisabled: s,
    isSelected: e,
    className: d,
    children: [
      /* @__PURE__ */ r.jsx(
        "div",
        {
          "data-id": "check-icon",
          className: v({ checked: e, disabled: s, error: a }),
          children: e && /* @__PURE__ */ r.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              children: /* @__PURE__ */ r.jsx(
                "path",
                {
                  d: "M4.35982 7.39202L2.87769 8.73317L6.5114 12.7572L13.5542 5.70712L12.1414 4.29291L6.58447 9.85565L4.35982 7.39202Z",
                  fill: s ? t.colors.root.neutral[300] : t.colors.root.neutral[0]
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ r.jsx(o, { noMargin: !0, children: c }),
      a && /* @__PURE__ */ r.jsx("div", { className: g, children: /* @__PURE__ */ r.jsx(o, { noMargin: !0, size: "s", color: "root.red.600", children: i || "error message" }) })
    ]
  }
);
export {
  j as C
};
//# sourceMappingURL=Checkbox-CIt7C3d4.js.map
